import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userStartUpdateForPreferences } from "../../app/actions/userActions";
import { schemaValidateUsersListPreferences } from "../../app/data/schemaValidateUsersListPreferences";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewInputGenericPassword from "../generic-component/NewInputGenericPassword";
import NewInputGenericReadOnly from "../generic-component/NewInputGenericReadOnly";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";

const ID_FORM = "admin-user";
const PAGE = "preferences";

const PROFILE_SKIP = new Set(["id", "password", "email", "deleted", "options"]);

const EditUserPreferences = ({ embedded = false }) => {
  debugLogPages(':: EditUserPreferences');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { userSelectedForPreferences } = useSelector((state) => state.user);

    const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation, setValues } = useFormValidationsGeneric(
      () => userCallback(),
      userSelectedForPreferences,
      schemaValidateUsersListPreferences
    );

  function userCallback() {
    debugLogPages(':: EditUsers, userCallback, values', {values}); 

    let valuesSubmit = { ...values };
    valuesSubmit.deleted = false;
    valuesSubmit.isChangedPassword = false;
    valuesSubmit.passwordEncrypt = values.passwordEncrypt || values.password;
    valuesSubmit.password = valuesSubmit.passwordEncrypt;

    debugLogPages(':: EditUsers, userCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(userStartUpdateForPreferences(valuesSubmit, navigate));

  }

    debugLogPages(':: EditUsers', {errors}); 
    debugLogPages(':: EditUsers', {values}); 

  return (
    <div>
      {!embedded && <NavbarIconsGenericComponent componentName="UserPreferences" />}
      {!embedded && <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${PAGE}`)}</div>}
      {!embedded && <hr className="line-hr" />}

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

          {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateUsersListPreferences && schemaValidateUsersListPreferences.length > 0 && (
                  schemaValidateUsersListPreferences.map((techSecondary, index) => {

                    if (PROFILE_SKIP.has(techSecondary.field)) {
                      return null;
                    }

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    }else if (techSecondary.component_new === "NewInputGenericReadOnly") {
                      return (
                        <NewInputGenericReadOnly
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } if (techSecondary.component_new === "NewInputGenericPassword") {
                      return (
                        <NewInputGenericPassword
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          setValues={setValues}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUserPreferences;
